import { createContext, useContext } from 'react';
import useCart from './useCart';
import { CartProviderResults } from './types';

type Ctx = CartProviderResults;

const CartPageContext = createContext<Ctx | null>(null);

export function useCartContext() {
  const ctx = useContext(CartPageContext);

  if (!ctx) {
    throw new Error('useCart must be used within CartPageProvider');
  }

  return ctx;
}

export function CartPageProvider({ children }: { children: React.ReactNode }) {
  const value = useCart();

  return (
    <CartPageContext.Provider value={value}>
      {children}
    </CartPageContext.Provider>
  );
}
